export default __webpack_public_path__ + "static/media/susd.fc130c10.svg";